import { render } from "./carousel-dots.vue?vue&type=template&id=7a061fde&scoped=true"
import script from "./carousel-dots.vue?vue&type=script&lang=js"
export * from "./carousel-dots.vue?vue&type=script&lang=js"

import "./carousel-dots.vue?vue&type=style&index=0&id=7a061fde&scoped=true&lang=css"

import exportComponent from "/home/runner/work/metal-client/metal-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a061fde"]])

export default __exports__